import {useCallback, useEffect, useRef, useState} from "react";
import {DropMenuActivationType} from "./DropdownMenuTypes";

const useDropdownMenu = (props: DropMenuActivationType) => {
    const [menuData, setMenuData] = useState({ x: 0, y: 0, open: false, positionClass: '' });

    const eventRef = useRef<MouseEvent>();
    const targetRef = useRef<HTMLDivElement>();

    const menuRef = useRef<any>();

    const updateMenuRef = useCallback((el: any) => {
        menuRef.current = el;
    }, []);

    const closeMenu = useCallback(() => {
        setMenuData({...menuData, open: false });
    }, [menuData]);

    const updateMenuPosition = useCallback(() => {

        if(targetRef.current && menuRef.current) {
            let newX = eventRef.current?.clientX ?? 0;
            let newY = eventRef.current?.clientY ?? 0;

            const parentContainer = menuRef.current.offsetParent as HTMLDivElement;
            let positionClass = '';

            if (newX + (menuRef.current.offsetWidth * 1.5) > parentContainer?.offsetWidth) {
                newX = newX - menuRef.current.offsetWidth;
                positionClass = 'from-end';
            }

            if (newX < 0) {
                newX = 0;
            }

            if (newY + (menuRef.current.offsetHeight * 1.5) > parentContainer.offsetHeight) {
                newY = newY - menuRef.current.offsetHeight;
            }

            if (newY < 0) {
                newY = 0;
            }

            setMenuData({
                x: newX,
                y: newY,
                open: true,
                positionClass: positionClass
            });
        }
    },[eventRef, targetRef, menuRef]);

    const handleMenuActivation = useCallback((event: any) => {
        eventRef.current = event;
        targetRef.current = event.target;

        let exclusionHit = false;

        if(props.exclusions) {
            exclusionHit = props.exclusions.some((exclusion) => {
                return targetRef.current?.matches(`.${exclusion}`) || targetRef.current?.closest(`.${exclusion}`) !== null;
            });
        }

        if(!exclusionHit) {
            targetRef.current = props.target.map((target) => {
                return event.target.matches(`.${target}`) ? event.target as HTMLDivElement : event.target.closest(`.${target}`) as HTMLDivElement;
            })[0];

            if(targetRef.current) {
                event.preventDefault();
                updateMenuPosition();
            }
        }
    }, [menuData, updateMenuPosition]);

    useEffect(() => {
        const handleClick = (e: { target: any }) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                closeMenu();
            }
        };

        if(!props.blockOnPrimaryClick) {
            document.addEventListener("click", handleMenuActivation);
        }

        if(props.activateOnContextClick) {
            document.addEventListener("contextmenu", handleMenuActivation);
        }

        document.addEventListener('mousedown', handleClick);

        return () => {
            if(!props.blockOnPrimaryClick) {
                document.removeEventListener("click", handleMenuActivation);
            }
            if(props.activateOnContextClick) {
                document.removeEventListener("contextmenu", handleMenuActivation);
            }

            document.removeEventListener('mousedown', handleClick);
        };
    }, [menuData]);

    return { menuData, targetRef, closeMenu, updateMenuPosition, updateMenuRef };
};

export default useDropdownMenu